(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["golf-help-centre"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('golf-help-centre')) {
  customElements.define('golf-help-centre', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.category = 'all';
      this.input = this.querySelector('input[type="search"]');
      this.groups = [...this.querySelectorAll('.gh-group')];
      this.questions = [...this.querySelectorAll('.gh-question')];
      this.normalise = text => text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[’']/g, '');
      this.questions.forEach((question, index) => {
        question.id = this.id + '-answer-' + index;
        question.dataset.search = this.normalise(question.closest('.gh-group').querySelector('h2').textContent + ' ' + question.textContent);
      });
      this.querySelector('.gh-search-box').addEventListener('submit', event => { event.preventDefault(); this.update(); this.showResults(); });
      this.querySelector('.gh-view-results').addEventListener('click', () => this.showResults());
      this.querySelectorAll('.gh-search-wrap,.gh-topic-list,.gh-results-bar').forEach(el => el.hidden = false);
      this.input.addEventListener('input', () => { this.category = 'all'; this.update(); });
      this.querySelector('.gh-clear').addEventListener('click', () => { this.input.value = ''; this.update(); this.input.focus(); });
      this.querySelector('.gh-reset').addEventListener('click', () => { this.input.value = ''; this.category = 'all'; this.update(); });
      this.querySelectorAll('[data-topic]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault(); this.category = link.dataset.topic; this.input.value = ''; this.update();
        const heading = this.groups.find(group => group.dataset.category === this.category).querySelector('h2');
        heading.focus({preventScroll:true}); heading.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'start'});
      }));
      this.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => { this.category = button.dataset.filter; this.input.value = ''; this.update(); }));
      this.update();
    }
    showResults(question) {
      const target = question ? question.querySelector('summary') : this.querySelector('.gh-answer-content');
      if (question) question.open = true;
      this.input.blur();
      target.focus({preventScroll:true});
      target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'start'});
    }
    update() {
      const tokens = this.normalise(this.input.value.trim()).split(/\s+/).filter(Boolean);
      let count = 0;
      this.groups.forEach(group => {
        let visible = 0;
        group.querySelectorAll('.gh-question').forEach(question => {
          const match = (this.category === 'all' || this.category === group.dataset.category) && tokens.every(token => question.dataset.search.includes(token));
          question.hidden = !match;
          if (tokens.length) question.open = match;
          else if (this.hadSearch) question.open = false;
          if (match) visible++;
        });
        group.hidden = visible === 0; count += visible;
      });
      this.hadSearch = tokens.length > 0;
      this.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === this.category)));
      this.querySelectorAll('[data-topic]').forEach(link => { if (link.dataset.topic === this.category) link.setAttribute('aria-current','true'); else link.removeAttribute('aria-current'); });
      this.querySelector('.gh-status').textContent = count + ' ' + (tokens.length ? (count === 1 ? this.dataset.oneMatch : this.dataset.matchLabel) : (count === 1 ? this.dataset.oneLabel : this.dataset.countLabel));
      const suggestions = this.querySelector('.gh-suggestions');
      suggestions.hidden = !tokens.length;
      this.querySelector('.gh-search-status').textContent = this.querySelector('.gh-status').textContent;
      this.querySelector('.gh-search-empty').hidden = count !== 0;
      this.querySelector('.gh-view-results').hidden = count === 0;
      const list = this.querySelector('.gh-suggestion-list');
      list.replaceChildren();
      if (tokens.length) {
        this.questions.filter(question => !question.hidden).slice(0, 6).forEach(question => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = '#' + question.id;
          const category = document.createElement('span');
          category.textContent = question.closest('.gh-group').querySelector('h2').textContent.replace(/^\s*\d+\s*/, '').trim();
          const title = document.createElement('strong');
          title.textContent = question.querySelector('summary').textContent.trim();
          link.append(category, title);
          link.addEventListener('click', event => { event.preventDefault(); this.showResults(question); });
          item.append(link); list.append(item);
        });
      }
      this.querySelector('.gh-empty').hidden = count !== 0;
      this.querySelector('.gh-clear').hidden = !this.input.value;
      this.querySelector('.gh-reset').hidden = !tokens.length && this.category === 'all';
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
